
import React, { useState } from 'react';

const IndustriesSection: React.FC = () => {
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);

  const industries = [
    {
      icon: 'ri-heart-pulse-line',
      title: 'Health & Wellness',
      description: 'Automate patient scheduling, follow-ups, and care coordination.',
      image: 'https://public.readdy.ai/ai/img_res/a99a973d591765923a26dbac1d85267a.jpg'
    },
    {
      icon: 'ri-home-4-line',
      title: 'Home Services',
      description: 'Streamline booking, dispatching, and customer communications.',
      image: 'https://readdy.ai/api/search-image?query=Clean%20modern%20home%20interior%20with%20minimalist%20design%2C%20white%20walls%2C%20natural%20lighting%2C%20simple%20furniture%2C%20professional%20home%20services%20aesthetic%2C%20Apple-inspired%20clean%20design&width=400&height=300&seq=home-services&orientation=landscape'
    },
    {
      icon: 'ri-bank-line',
      title: 'Finance',
      description: 'Enhance client onboarding and portfolio management processes.',
      image: 'https://readdy.ai/api/search-image?query=Modern%20financial%20office%20with%20clean%20minimalist%20design%2C%20white%20interior%2C%20professional%20banking%20environment%2C%20simple%20geometric%20elements%2C%20natural%20lighting%2C%20Apple-inspired%20aesthetic&width=400&height=300&seq=finance&orientation=landscape'
    },
    {
      icon: 'ri-briefcase-line',
      title: 'Professional Services',
      description: 'Optimize client intake, project management, and billing workflows.',
      image: 'https://readdy.ai/api/search-image?query=Clean%20modern%20professional%20office%20space%2C%20minimalist%20white%20interior%20design%2C%20simple%20furniture%2C%20natural%20lighting%2C%20business%20consulting%20environment%2C%20Apple-inspired%20aesthetic&width=400&height=300&seq=professional&orientation=landscape'
    },
    {
      icon: 'ri-building-line',
      title: 'Real Estate',
      description: 'Automate lead qualification, property tours, and client follow-ups.',
      image: 'https://readdy.ai/api/search-image?query=Modern%20real%20estate%20office%20with%20clean%20minimalist%20design%2C%20white%20interior%2C%20professional%20property%20showcase%2C%20simple%20geometric%20elements%2C%20natural%20lighting%2C%20Apple-inspired%20aesthetic&width=400&height=300&seq=real-estate&orientation=landscape'
    }
  ];

  return (
    <section id="industries" className="py-32 bg-gray-50">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-20">
          <h3 className="text-4xl md:text-5xl font-light text-black mb-6 tracking-tight">
            Industries we serve
          </h3>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto font-light leading-relaxed">
            Tailored solutions for every business
          </p>
        </div>
        
        <div className="grid md:grid-cols-2 gap-8">
          {industries.map((industry, index) => (
            <div 
              key={index}
              className="relative group cursor-pointer overflow-hidden rounded-3xl h-80 bg-white"
              onMouseEnter={() => setHoveredIndex(index)}
              onMouseLeave={() => setHoveredIndex(null)}
            >
              <img
                src={industry.image}
                alt={industry.title}
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
              
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent"></div>
              
              <div className="absolute inset-0 flex flex-col justify-end p-8">
                <div className="transform transition-all duration-500 group-hover:-translate-y-2">
                  <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center mb-4">
                    <i className={`${industry.icon} text-lg text-black`}></i>
                  </div>
                  
                  <h4 className="text-2xl font-medium text-white mb-3 tracking-tight">
                    {industry.title}
                  </h4>
                  
                  <p className={`text-gray-200 text-lg font-light transition-all duration-500 ${
                    hoveredIndex === index ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
                  }`}>
                    {industry.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default IndustriesSection;
